import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getUserPreferences } from 'api/Preferences';

export const useUserPreferences = ({ params, dependencies = [], options }) => {
  const navigate = useNavigate();
  return useQuery(['preferences', ...dependencies], () => getUserPreferences(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
